module.exports = __webpack_public_path__ + "assets/img/files-memo.1558c8f0.svg";